import React from 'react';
import {Text, View} from 'react-native';
import {Table} from '../../../shared/components/table';
import {Column} from '../../../shared/components/table/model';
import {useStyles} from '../../../shared/hooks/styles';
import {Ticket} from '../../../shared/models/api/skipassResponsePayload';
import {useTheme} from '../../../shared/theme';
import {DeviceSize} from '../../../shared/theme/helpers';
import {formatDateTime} from '../../../shared/utils/formatDate';

interface TicketsTableProps {
  data: Ticket[] | undefined;
}

export function TicketsTable({data}: TicketsTableProps) {
  const styles = useStyles(({mediaOnly, theme}) => ({
    tableContainer: {
      ...mediaOnly(DeviceSize.desktop, {width: '80%'}),
    },
    colText: {
      ...theme.fonts.body,
      color: theme.color.textColor,
    },
    textCenter: {
      textAlign: 'center',
    },
    textRight: {
      textAlign: 'right',
    },
  }));

  const theme = useTheme();

  const columns: Column<Ticket>[] = [
    {
      title: 'Наименование',
      field: 'name',
      headStyles: {
        colHeadStyle: {flexBasis: '60%'},
      },
      styles: {
        colBodyTextStyle: styles.colText,
        colBodyStyle: {flexBasis: '60%'},
      },
      render: (row) => {
        return <Text style={styles.colText}>{row.name}</Text>;
      },
    },
    {
      title: 'Дата и время окончания',
      field: 'toIso',
      render: (row) => {
        return <Text style={[styles.colText, styles.textCenter]}>{formatDateTime(row.toIso)}</Text>;
      },
      headStyles: {
        colHeadTextStyle: styles.textCenter,
        colHeadStyle: {flexBasis: '25%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '25%'},
      },
    },
    {
      title: 'Активность',
      field: 'isActivated',
      render: (row) => {
        return (
          <Text
            style={[
              styles.colText,
              styles.textRight,
              {color: row.isActivated ? theme.skipass.greenColor : theme.skipass.redColor},
            ]}>
            {row.isActivated ? 'Активный' : 'Не активный'}
          </Text>
        );
      },
      headStyles: {
        colHeadTextStyle: styles.textRight,
        colHeadStyle: {flexBasis: '15%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '15%'},
      },
    },
  ];

  return (
    <View style={styles.tableContainer}>
      <Table data={data} columns={columns} />
    </View>
  );
}
